<template>
  <el-dialog title="工单跟进" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="falseValue"
             :visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog" width="700px"
             @close="dialogClose" v-el-drag-dialog v-el-dialog-center>
    <template>
      <div id="containt" style="height: 300px">

          <div class="table_main">
            <el-form>
              <el-form-item>
                  <span style="margin-right: 10px;margin-left: 100px;">是否通过APP通知网点:</span>
                 <el-checkbox  name="isToApp" v-model="remark.isToApp" value="1" ></el-checkbox>
              </el-form-item>
              <el-form-item label="设置工单标签" label-width="100px">
                <el-radio-group v-model="remark.dispatch" @change="radioHandleChange">
                  <el-radio v-for="item in dispatchStats"
                            :key="item.id" :label="item.dispatchStat">
                    {{item.dispatchStat}}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="当前跟进" label-width="100px">
                <el-input class="annotate" type="textarea" :rows="5" placeholder="请输入内容" size="small" style="width: 90%"
                          v-model="remark.remark" clearable  ></el-input>
              </el-form-item>
            </el-form>
          </div>
      </div>
    </template>
    <span slot="footer" class="dialog-footer">
			<el-button type="primary" plain class="button-sty" @click="dialogClose">
				<i class="el-icon-close el-icon"></i>
				取 消
			</el-button>
			<el-button type="primary" @click="commitRow" class="button-sty">
				<i class="el-icon-check el-icon"></i>
				确 定
			</el-button>
		</span>
  </el-dialog>
</template>

<script>
import { selectDialogMixins } from '@/mixins/selectDialog/index.js';
import request from "@/router/axios";
export default {
  name: 'saleConfigDialog',
  props: ['visiable', 'multi', 'param'],
  mixins: [selectDialogMixins],
  components: {  },

  created() {
    this.getDispatch();
  },


  data() {
    return {
      remark:{},
      showDialog: true,
      dispatchStats:[],
      fromData:{
        showInRemark : this.param?this.param.showInRemark?this.param.showInRemark:'':'',
      }
    };
  },


  methods: {
    commitRow() {
      this.$emit('commitUrge', this.urge)
      this.dialogClose()
    },
    getDispatch(){
      request({
        url: '/basic/basDispatchStat/getList',
        method: 'post',
        data:this.fromData,
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        this.dispatchStats = response.data.data
      })
    }




  }
};
</script>
<style lang="scss" scoped>
// 单选框的样式
::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon:before {
  top: -1px;
}

::v-deep.vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--checked-icon:after {
  top: 0.3em;
}


::v-deep .el-dialog {
  // height: 700px;
  overflow: hidden;
}

::v-deep body .dialog-style {
  border-radius: 8px;
  -webkit-box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  // height: 700px;
  overflow: hidden;
}

/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.table_main {
  padding-top: 5px;
  padding-left: 5px;
  border: 1px solid #ededed;
  // width: calc(100% - 215px);
  border-bottom: none;

  .el-pagination {
    padding: 2px;

  }
}

.left_tree {
  width: 205px;

  .title {
    text-align: left;
    width: 182px;
    padding: 7px 0 5px !important;
    font-size: 13px;
    color: rgba(58, 39, 39, 0.96);

    >span {
      position: relative;
      left: 4px;
      top: -3px;
    }
  }

  ::v-deep.el-tree-node__label {
    width: calc(100% - 32px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
  }
}

.tree_icon {
  background: #f0f3ff;
}

// 重新修改tree组件样式
::v-deep.tree-line {
  .el-tree-node {
    position: relative;
    padding-left: 0px;
  }

  .el-tree-node__content {
    margin-top: 0px;
  }

  .el-tree-node__children {
    padding-left: 16px;
  }

  .el-tree-node::before {
    content: '';
    height: 100%;
    width: 1px;
    position: absolute;
    left: -3px;
    top: -26px;
    border-width: 1px;
    border-left: 1px dashed #d9d9d9;
  }

  .el-tree-node:last-child::before {
    height: 38px;
  }

  .el-tree-node::after {
    content: '';
    width: 24px;
    height: 1px;
    position: absolute;
    left: -3px;
    top: 12px;
    border-width: 1px;
    border-top: 1px dashed #d9d9d9;
  }

  &>.el-tree-node::after {
    border-top: none;
  }

  &>.el-tree-node::before {
    border-left: none;
  }

  .el-tree-node__expand-icon {
    font-size: 17px;

    // color: #000;
    &.is-leaf {
      color: transparent;
      // display: none;
    }
  }
}
::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon {
  font-size: 14px !important;
}
.vxe-grid .vxe-grid--pager-wrapper {
  display: block;
  width: 100%;
  position: fixed;
  bottom: -38px !important;
  position: absolute !important;
  z-index: 9999999;
  background-color: #ffffff;
}
// ::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon {
//     font-size: 14px !important;
// }
</style>
